// extracted by mini-css-extract-plugin
module.exports = {"brandTitle":"brandTitle___29UFm","partnerListItem":"partnerListItem___1BKM9"};